import { isNullOrUndefined } from "./IsNullOrUndefined";
/**
 * cast the error to AC3BaseError if the errorCode is present
 * otherwise, return undefined
 */
export function castToAC3BaseErrorIfWithErrorCode(error) {
    var _a;
    if (isNullOrUndefined(error)) {
        return undefined;
    }
    try {
        const castError = error;
        if (isNullOrUndefined((_a = castError === null || castError === void 0 ? void 0 : castError.errorCodeContext) === null || _a === void 0 ? void 0 : _a.errorCode)) {
            return undefined;
        }
        return castError;
    }
    catch (error) {
        // intentionally do nothing
    }
    return undefined;
}
//# sourceMappingURL=CastToAC3BaseErrorIfWithErrorCode.js.map